<template>
    <div class="col-span-2" v-bind:class="short ? 'h-16' : 'h-32'">
        <div class="text-gray-700 font-medium text-sm right lg:text-right pl-2">
            Saldo em conta
        </div>
        <div class="relative">
            <div
                class="absolute -left-11 -top-1 h-9 w-9 rounded-full border flex justify-center items-center cursor-pointer"
                @click="loadBalance"
            >
                <i class="fas mx-1" :class="{'fa-eye': !showBalance,'fa-eye-slash': showBalance}" />
            </div>
            <div
                class="font-bold text-gray-800 text-xl text-right pl-2">
                <div v-bind:class="{'bg-gray-200 text-gray-200 rounded-md text-opacity-0': !showBalance,'': showBalance,}">
                    <span class="text-base">R$</span> {{ $page.props.activeAccount.balance.value | currency }}
                </div>
            </div>
        </div>
        <div class="text-gray-700 text-xs text-center lg:text-right pl-2">
            Atualizado em {{ $page.props.activeAccount.balance.updated | smallDateTime }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        short: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showBalance: false,
            balance: {
                value: null,
                blocked: null,
                updated: null
            }
        }
    },
    created() {
    },
    methods: {
        loadBalance() {
            this.showBalance = !this.showBalance
        }
    }
}
</script>
